import { render } from "./Tracker.vue?vue&type=template&id=1dbc861f"
import script from "./Tracker.vue?vue&type=script&lang=js"
export * from "./Tracker.vue?vue&type=script&lang=js"
script.render = render

export default script